import React, { useEffect, useState } from "react";
import { getClassFiveBudget } from "../../api/server";

export default function AttorneyReferralStatus({ userId }) {
  const [result, setResult] = useState(null);

  useEffect(() => {
    let active = true;
    setResult(null);
    if (!userId) return () => { active = false; };
    getClassFiveBudget("admin", userId)
      .then(({ data }) => {
        if (active) setResult({ userId, choice: data?.data?.forms?.report?.savedReferral });
      })
      .catch(() => {
        if (active) setResult({ userId, choice: null });
      });
    return () => { active = false; };
  }, [userId]);

  const choice = result?.userId === userId ? result.choice : null;

  return (
    <div className="row" role="group" aria-label="Attorney Referral Request">
      <div className="col-lg-6 mb-4">
        <span className="from-label">Attorney Referral Request</span>
      </div>
      <div className="col-lg-6 mb-4">
        {["yes", "no"].map((value) => (
          <div className="iagree_radio form-check-inline" key={value}>
            <div>
              <input
                type="checkbox"
                id={`attorney-referral-${value}`}
                checked={choice === value}
                disabled
                readOnly
              />
              <label htmlFor={`attorney-referral-${value}`}>{value === "yes" ? "Yes" : "No"}</label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
